// File: src/blueprint/app/routes.js

/**
 * GOAL:
 * - Define route constants and helper functions for Blueprint Runner navigation.
 *
 * OUT OF SCOPE (for now):
 * - Complex URL params / deep linking.
 *
 * SPIKE REFERENCE:
 * - SPIKE: src/intake/state/useIntakeRouter.js (route mapping ideas)
 */
export const ROUTES = {
  ENTRY: 'entry',
  OVERVIEW: 'overview',
  MODULE: 'module',
};
